import React from "react";
import "./Footer.css";
import logo from "../../assets/images/footer/logo-btm.webp";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="footer-wrapper">
      <div className="container">
        <div className="footer-view">
          <img className="logo" src={logo} alt="" />
          <div className="footer-items-view">
            <div className="topView" style={{ marginBottom: "8px" }}>
              <a>{t("btm.started")}</a>
              <a>{t("btm.about")}</a>
            </div>
            <div className="btmView">
              <a>{t("btm.download")}</a>
              <a>{t("btm.contact")}</a>
            </div>
          </div>
          <img className="logo-btm" src={logo} alt="" />
        </div>
      </div>
    </footer>
  );
}
export default Footer;
